import { useContext } from 'react';
import ThemeContext from '../../contexts/ThemeContext';

const useThemeContext = () => {
  const ctx = useContext(ThemeContext);

  if (!ctx) {
    throw new Error('useThemeContext must be used inside ThemeProvider');
  }
  return ctx;
};

export default useThemeContext;
